import { Link } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import { AdminSidebar } from '@/components/layout/AdminSidebar'

interface Series {
  id: number; title: string; slug: string
  description: string | null; episodes_count: number
}

export default function Index({ series }: { series: Series[] }) {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AdminSidebar active="/admin/series" />
      <main className="flex-1 p-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Series</h1>
          <Link href="/admin/series/new"><Button>+ New series</Button></Link>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-400 uppercase tracking-wider">Title</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-400 uppercase tracking-wider">Episodes</th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-400 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {series.map(s => (
                <tr key={s.id} className="hover:bg-gray-50/50">
                  <td className="px-5 py-4">
                    <p className="font-medium text-gray-900 text-sm">{s.title}</p>
                    <p className="text-xs text-gray-400 mt-0.5 line-clamp-1">{s.description}</p>
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-500">{s.episodes_count}</td>
                  <td className="px-5 py-4 text-right">
                    <Link href={`/admin/series/${s.slug}/edit`} className="text-sm text-gray-600 hover:text-gray-900 mr-3">Edit</Link>
                    <Link
                      href={`/admin/series/${s.slug}`} method="delete" as="button"
                      className="text-sm text-red-500 hover:text-red-700"
                      onClick={(e) => { if (!confirm('Delete this series?')) e.preventDefault() }}
                    >Delete</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {series.length === 0 && (
            <div className="py-16 text-center text-gray-400 text-sm">No series yet.</div>
          )}
        </div>
      </main>
    </div>
  )
}
